import { createFileRoute } from '@tanstack/react-router';
import { Templates } from '../../../features/management/templates/templates';
import {
  createPermissionGuard,
  getPermissionSet,
  TEMPLATES_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/vorlagen/')({
  component: Templates,
  beforeLoad: createPermissionGuard(
    getPermissionSet(TEMPLATES_PERMISSIONS, 'EDIT'),
  ),
});

export const ListTemplatesRoute = Route;
